import * as ActionLogin from '../../../module/Login/Store';
import * as ActionManualHoliday from '../../action/Holiday/ActionFormManualHoliday';
import * as ActionTableHoliday from '../../action/Holiday/ActionTableHoliday';
import * as toggle from '../../action/toggle';

import { call, put, select, takeLatest } from 'redux-saga/effects';

import { ErrorMassage } from '../../ErrorMassage/index';
import { Modal } from 'antd';
import React from 'react';
import axios from 'axios';
import moment from 'moment';

export function* S_addManualHoliday() {
  const state = yield select();
  const HolidayDate = state.Holiday.FormManualHoliday.DateHoliday;
  const HolidayEvent = state.Holiday.FormManualHoliday.EventHoliday;
  const token = state.Auth.Token;
  const config = {
    Authorization: `bearer ${token}`,
    'Content-type': 'application/json',
  };
  try {
    yield put(toggle.changeLoadingTrue());
    yield call(
      axios.post,
      process.env.REACT_APP_URL + '/Holiday',
      {
        date: moment(HolidayDate).format('MM-DD-YYYY'),
        eventName: HolidayEvent,
      },
      {
        headers: config,
      }
    );
    yield put(ActionTableHoliday.GetTableHoliday());
    yield put(ActionManualHoliday.clearAllFormManualHoliday());
    yield put(toggle.changeModal());
    yield put(toggle.clearJenisToggle());
    yield put(toggle.changeLoadingFalse());

    Modal.success({
      title: (
        <p style={{ color: '#31E116' }}>Berhasil menambahkan hari libur</p>
      ),

      onOk() {},
    });
  } catch (error) {
    if (error.response.status === 401) {
      yield put(ActionLogin.submitTokenRefrash());
    } else {
      yield put(toggle.changeLoadingFalse());
      if (
        error.response.status === 500 &&
        error.response.data.Message === 'Date was created before!'
      ) {
        Modal.error({
          title: (
            <p style={{ color: '#FF0000' }}>
              {'Tanggal sudah ada di hari libur!!!'}
            </p>
          ),
          content: <div>Silakan pilih tanggal lainnya</div>,
          onOk() {},
        });
      } else if (error.response.status === 401) {
        yield put(ActionLogin.submitTokenRefrash());
      } else {
        const propsError = ErrorMassage('Tambah libur manual');
        const code = propsError.filter((person: any) =>
          person.Code.toString().toLowerCase().includes(error.response.status)
        );
        Modal.error({
          title: (
            <p style={{ color: '#FF0000' }}>
              {code.map((data: any) => data.TitleMassage)}
            </p>
          ),
          content: (
            <div>
              <p style={{ color: '#C0C0C0' }}>
                {code.map((data: any) => data.Massage)}
              </p>
            </div>
          ),
          onOk() {},
        });
      }
    }
  }
}

export function* SM_addManualHoliday() {
  yield takeLatest('ADD_MANUAL_HOLIDAY', S_addManualHoliday);
}
